/**
 * Новая версия приложения, готовая к применению.
 *
 * Вкладка, открытая часами, живёт на той сборке, с которой загрузилась:
 * служебный процесс проверяет обновление только при регистрации. Хук
 * спрашивает сервер время от времени и сообщает, когда новая версия встала.
 *
 * Перезагрузку выполняет человек: страница, перезагрузившаяся сама посреди
 * упражнения, теряет набранное (ТЗ FR-EN-69).
 */

import { useCallback, useEffect, useState } from 'react';
import { applyAppUpdate, watchAppUpdate } from '@type2x/adapter-web';

export interface AppUpdateState {
  /** Новая версия готова: осталось перезагрузить страницу. */
  readonly ready: boolean;
  readonly apply: () => void;
}

export function useAppUpdate(): AppUpdateState {
  const [ready, setReady] = useState(false);

  useEffect(() => watchAppUpdate(() => setReady(true)), []);

  return { ready, apply: useCallback(() => applyAppUpdate(), []) };
}
